import { gql } from '@reverbdotcom/commons/src/gql';
import React from 'react';
import { CreditCardWalletRowFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import CreditCardWalletRowSummary from './credit_card_wallet_row_summary';

type CreditCard = CreditCardWalletRowFieldsFragment['creditCards'][0];

interface Props {
  creditCard: CreditCard;
}

export default function CreditCardWalletRow(props: Props) {
  const { creditCard } = props;

  return (
    <CreditCardWalletRowSummary creditCard={creditCard} />
  );
}

export const CreditCardWalletRowFragment = gql(`
  fragment CreditCardWalletRowFields on rql_Me {
    _id
    uuid
    creditCards {
      id
    }
    ...CreditCardWalletRowSummaryFields
  }
`);
